export default {
  partyId: (state) => state.userSession?.currentBu?.id || state.userSession?.buList?.[0]?.id,
  currentShop: (state) => state.currentShop || {},
  merchantCode: (state) => state.userSession?.merchantCode,
  isRent: (state) => state.userSession?.trade === 'RENT',
  // 检查指定的功能代码是否存在
  hasFunction: (state) => (code) => {
    const searchInList = (list) => {
      for (const item of list) {
        if (item.code === code) {
          return true
        }
        if (item.children && item.children.length > 0) {
          if (searchInList(item.children)) {
            return true
          }
        }
      }
      return false
    }

    const funcList = state.userSession?.funcList || []
    return searchInList(funcList)
  },
}
